import { EException } from 'types/response-code/jira';

export const jiraErrorMessageInfo: Record<EException, string> = {
  '-1': 'Vui lòng kiểm tra lại thông tin'
};
